/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import { forwardRef } from 'react';
import Icon, { IconProps } from '../../DataDisplay/Icon/Icon';
import styles from './DropDownIndicator.module.scss';

export interface DropDownIndicatorProps {
  icon?: IconProps;
  label?: string | React.JSX.Element;
  variant?: 'bubble' | 'filter' | 'plain' | 'lined' | 'multi' | 'multiFilter' | 'outlined';
  float?: 'left' | 'right';
  showAngleDown?: boolean;
  showPointer?: boolean;
  indicatorMinHeight?: string;
  fontColor?: string;
  disabled?: boolean;
  header?: boolean;
  onClick?: () => void;
}

const DropDownIndicator = forwardRef<HTMLDivElement, DropDownIndicatorProps>(
  (
    {
      icon,
      label,
      float = 'left',
      showAngleDown = true,
      showPointer = true,
      disabled = false,
      indicatorMinHeight,
      header = true,
      fontColor,
      variant,
      onClick = () => {},
    },
    ref,
  ) => {
    if (!header) return null;

    return (
      <div
        ref={ref}
        className={[
          styles.container,
          styles[float],
          styles[getPointerClass()],
          styles[variant || ''],
          styles[getDisabledClass()],
        ].join(' ')}
        style={{ minHeight: indicatorMinHeight, color: fontColor }}
        onClick={() => {
          if (!disabled) {
            onClick();
          }
        }}
        tabIndex={0}
      >
        <div className={styles.option}>
          {label}
          {icon && <Icon {...icon} />}
        </div>
        {showAngleDown && <Icon icon="angleDown" size="xsm" />}
      </div>
    );

    function getPointerClass() {
      return showPointer ? 'pointer' : '';
    }

    function getDisabledClass() {
      return disabled ? 'disabled' : '';
    }
  },
);

export default DropDownIndicator;
